import "./lobby-student.less";
import {boolOr} from "utils/helpers";
import { PropsWithChildren } from "react";

interface Props {
  className?: string
  active?: boolean
  kickable?: boolean
  onClick?: () => void
  onKickOut?: () => void
}

export default function LobbyStudent(props: PropsWithChildren<Props>) {
  const {} = props;

  const kickable = boolOr(props.kickable, false)
  
  let className = "lobby-student";
  if (props.className) {
    className += " " + props.className;
  }
  if (!!props.active) {
    className += " active";
  } else {
    className += " inactive";
  }
  if (kickable) {
    className += ' kickable'
  }

  return <div className={className} onClick={props.onClick}>
    {props.children}
    {kickable &&
      <div className="kickout" onClick={props.onKickOut}>&#10006;</div>  
    }
  </div>
}
